import React, { useCallback } from 'react';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../../icons/components/Icon';
import { COLORS } from '../../constants';
const useStyles = makeStyles()((theme) => {
    return {
        label: {
            ...theme.typography.labelRegular,
            alignItems: 'center',
            background: theme.palette.labelBackground,
            borderRadius: '4px',
            color: theme.palette.labelText,
            display: 'flex',
            margin: '0 2px',
            padding: '6px',
            height: 28,
            boxSizing: 'border-box'
        },
        withIcon: {
            marginLeft: 8
        },
        clickable: {
            cursor: 'pointer'
        },
        [COLORS.white]: {
            background: theme.palette.labelWhiteBackground,
            color: theme.palette.labelWhiteText,
            '& svg': {
                fill: theme.palette.labelWhiteIcon
            }
        },
        [COLORS.green]: {
            background: theme.palette.success02
        },
        [COLORS.red]: {
            background: theme.palette.actionDanger
        }
    };
});
const Label = ({ accessibilityText, className, color, icon, iconColor, id, onClick, text }) => {
    const { classes, cx } = useStyles();
    const onKeyPress = useCallback((event) => {
        if (!onClick) {
            return;
        }
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onClick();
        }
    }, [onClick]);
    return (React.createElement("div", { className: cx(classes.label, onClick && classes.clickable, color && classes[color], className), id: id, onClick: onClick, onKeyPress: onKeyPress, role: onClick ? 'button' : undefined, tabIndex: onClick ? 0 : undefined },
        icon && React.createElement(Icon, { color: iconColor, size: "16", src: icon }),
        accessibilityText && (React.createElement("span", { className: "sr-only" }, accessibilityText)),
        text && React.createElement("span", { className: icon && classes.withIcon }, text)));
};
export default Label;
// /**
//  * React Component for showing short text in a circle.
//  *
//  * @augments Component
//  */
// class Label extends AbstractLabel<Props, any> {
//     /**
//      * Implements React's {@link Component#render()}.
//      *
//      * @inheritdoc
//      */
//     render() {
//         const {
//             classes,
//             className,
//             color,
//             icon,
//             iconColor,
//             id,
//             onClick,
//             text,
//         } = this.props;
//         const labelClassName = clsx(
//             classes.label,
//             onClick && classes.clickable,
//             color && classes[color],
//             className
//         );
//         return (
//             <div className={labelClassName} id={id} onClick={onClick}>
//                 {icon && <Icon color={iconColor} size="16" src={icon} />}
//                 {text && (
//                     <span className={icon && classes.withIcon}>{text}</span>
//                 )}
//             </div>
//         );
//     }
// }
// export default withStyles(styles)(Label);
